import { Box } from '@mui/material'

import { figmaButtonArrow, figmaButtonArrowNavy } from '../../assets/index'



const arrowImageSx = {

  position: 'absolute',

  inset: '-4.69% -7.5% -3.39% -7.5%',

  width: 'calc(100% + 15%)',

  height: 'calc(100% + 8.08%)',

  maxWidth: 'none',

  display: 'block',

}



export default function FigmaButtonArrow() {

  return (

    <Box

      sx={{

        width: { xs: 12, sm: 16 },

        height: { xs: 7.5, sm: 10 },

        display: 'flex',

        alignItems: 'center',

        justifyContent: 'center',

        flexShrink: 0,

      }}

    >

      <Box

        sx={{

          width: { xs: 7.5, sm: 10 },

          height: { xs: 12, sm: 16 },

          transform: 'rotate(-90deg)',

          flexShrink: 0,

          position: 'relative',

        }}

      >

        <Box

          component="img"

          src={figmaButtonArrow}

          alt=""

          className="figma-btn-arrow-light"

          sx={arrowImageSx}

        />

        <Box

          component="img"

          src={figmaButtonArrowNavy}

          alt=""

          className="figma-btn-arrow-dark"

          sx={arrowImageSx}

        />

      </Box>

    </Box>

  )

}


